module.exports = __webpack_public_path__ + "img/9788958075387.81496b94.jpg";